<template>
  <div class="shipment-wrapper">
    <Banner
      :detail="detail"
      :activeTab="activeTab"
      @changeTab="(tab) => (activeTab = tab)"
    />

    <div class="shipment-content-wrapper">
      <div class="shipment-content">
        <BaseInfo v-if="activeTab === 'base'" :detail="detail" />

        <GoodsTab
          v-if="activeTab === 'goods'"
          :shipmentCode="shipmentCode"
          @reload="getData"
        />

        <ContainerTab
          v-if="activeTab === 'container'"
          :shipmentCode="shipmentCode"
          :shipmentNo="detail.shipmentNo"
          @reload="getData"
        />

        <BookingTab
          v-if="activeTab === 'booking'"
          :shipmentCode="shipmentCode"
          @reload="getData"
        />
      </div>
    </div>
  </div>
</template>

<script>
const TabMaps = { detail: 'base', container: 'container', booking: 'booking' }

import EditLoading from '@/mixins/edit-loading'
import Banner from './components/banner.vue'
import BaseInfo from './components/base-info.vue'
import GoodsTab from './components/goods/index.vue'
import ContainerTab from './components/container/index.vue'
import BookingTab from './components/booking/index.vue'

export default {
  name: 'ecom-shipment-management-shipment-orders-detail',
  components: {
    Banner,
    BaseInfo,
    GoodsTab,
    ContainerTab,
    BookingTab,
  },
  mixins: [EditLoading],
  data() {
    return {
      activeTab: 'base',
      detail: {},
    }
  },
  computed: {
    pageType() {
      return this.$route.params.pageType || 'detail'
    },
    shipmentCode() {
      return this.$route.params.shipmentCode || ''
    },
  },
  mounted() {
    this.activeTab = TabMaps[this.pageType] || 'base'

    this.getData()
  },
  methods: {
    async getData() {
      if (!this.shipmentCode) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomShipmentInfoDetailApi({ shipmentCode: this.shipmentCode })
        .catch(() => null)
      this.loadingClose()

      if (!res) return

      if (res.status !== 200) {
        this.$message.error(res.msg)
        return
      }

      this.detail = res.body || {}
    },
  },
}
</script>

<style lang="scss" scoped>
.shipment-wrapper {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
}

.shipment-content-wrapper {
  flex-grow: 1;
  position: relative;

  .shipment-content {
    position: absolute;
    inset: 0;
    padding: 16px;
    display: flex;
    flex-direction: column;
  }
}
</style>
